import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { GlobalContext } from './context/GlobalContext'
import { getToken } from './lib/haxios'
import logo from './images/logo.png'
import bgImage from './images/bg.jpg'

function Login() {
  const navigate = useNavigate()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [rememberMe, setRememberMe] = useState(false)
  const { loginError, setLoginError, setLoading } = useContext(GlobalContext)
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    const remembered = localStorage.getItem('rememberMe') === 'true'
    const storedUsername = localStorage.getItem('rememberedUsername')
    const storedPassword = localStorage.getItem('rememberedPassword')
    if (remembered && storedUsername && storedPassword) {
      setUsername(storedUsername)
      setPassword(storedPassword)
      setRememberMe(true)
    }
  }, [])

  const handleSubmit = async () => {
    if (!username || !password) {
      setLoginError('Please enter both username and password')
      return
    }

    setIsSubmitting(true)
    setLoginError('')

    try {
      const res = await getToken(username, password)
      if (!res) {
        setLoginError('Invalid username or password.')
        return
      }

      if (rememberMe) {
        localStorage.setItem('rememberMe', 'true')
        localStorage.setItem('rememberedUsername', username)
        localStorage.setItem('rememberedPassword', password)
      } else {
        localStorage.removeItem('rememberMe')
        localStorage.removeItem('rememberedUsername')
        localStorage.removeItem('rememberedPassword')
      }

      setLoading(true)
      navigate('/')
    } catch (error) {
      setLoginError('Login failed. Please try again.')
      console.error('Login error:', error)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="flex fixed inset-0 min-h-screen">
      {/* Background image - hidden on mobile, visible on medium screens and up */}
      <div
        className="hidden md:block w-1/2 bg-blue-500 bg-center bg-cover"
        style={{ backgroundImage: `url(${bgImage})` }}
      />
      {/* Login form - full width on mobile, half width on desktop */}
      <div className="flex justify-center items-center p-4 md:p-10 w-full md:w-1/2 bg-gradient-to-r from-blue-500 to-purple-600">
        <div className="w-full max-w-md">
          <div className="flex justify-center mb-4 md:mb-6">
            <img src={logo} alt="Logo" className="object-contain max-h-12 md:max-h-16" />
          </div>
          <form
            onSubmit={(e) => {
              e.preventDefault()
              handleSubmit()
            }}
          >
            <div className="mb-4 md:mb-6">
              {loginError && <div className="mb-3 md:mb-4 text-sm md:text-base font-bold text-center text-red-400">{loginError}</div>}
              <div className="flex items-center py-3 md:py-2 border-b border-gray-200">
                <span className="mr-2 md:mr-3 text-white material-icons text-xl md:text-2xl">person</span>
                <input
                  className="px-2 py-2 md:py-1 w-full text-base md:text-sm leading-tight placeholder-gray-300 text-white bg-transparent border-none appearance-none focus:outline-none"
                  id="username"
                  type="text"
                  placeholder="Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  disabled={isSubmitting}
                  autoComplete="username"
                />
              </div>
            </div>
            <div className="mb-4 md:mb-6">
              <div className="flex items-center py-3 md:py-2 border-b border-gray-200">
                <span className="mr-2 md:mr-3 text-white material-icons text-xl md:text-2xl">lock</span>
                <input
                  className="px-2 py-2 md:py-1 w-full text-base md:text-sm leading-tight placeholder-gray-300 text-white bg-transparent border-none appearance-none focus:outline-none"
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyUp={(e) => e.key === 'Enter' && handleSubmit()}
                  disabled={isSubmitting}
                  autoComplete="current-password"
                />
                <span
                  className="ml-2 text-white material-icons cursor-pointer text-xl md:text-2xl"
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  {showPassword ? 'visibility_off' : 'visibility'}
                </span>
              </div>
            </div>
            <div className="flex justify-between items-center mb-4 md:mb-6 text-white text-sm">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  className="mr-2 w-4 h-4 md:w-auto md:h-auto"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <span className="text-sm md:text-base">Remember Me</span>
              </label>
            </div>
            <div className="flex justify-between items-center">
              <button
                className="px-4 py-3 md:py-2 w-full text-base md:text-sm font-bold text-black bg-yellow-300 rounded-lg shadow-lg transition-all duration-300 hover:bg-yellow-400 disabled:opacity-50 disabled:cursor-not-allowed"
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Logging in...' : 'Login'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Login
